export default __webpack_public_path__ + "static/media/icon-mitigation-notification.7ecf508e.svg";